import React, { useEffect, useState } from 'react'
import PercentageRangeSlider from 'components/PercentageRangeSlider'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const StyledHeading = styled.h2`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  margin: 15px;
  color: ${props => (props.color ? props.color : COLORS.BLACK)};
`

const CompletionFilter = ({ cardNumber,setCompletionChange,filterData,currentUrl }) => {
  const getInitialValues = () => {
    if (currentUrl && currentUrl.includes('completionStart') && currentUrl.includes('completionEnd')) {
      const params = new URLSearchParams(currentUrl);
      const start = parseInt(params.get('completionStart'), 10);
      const end = parseInt(params.get('completionEnd'), 10);
      return [start, end];
    }
    return [0, 100]; // Default values
  };

  const [minValue, setMinValue] = useState(getInitialValues()[0]);
  const [maxValue, setMaxValue] = useState(getInitialValues()[1]);
  
   const [tapNumber,setTapNumber] = useState(null);
    useEffect(() => {
      if(cardNumber!=tapNumber){
        setTapNumber(cardNumber);
        setMinValue(0)
        setMaxValue(100)
      }
    
      if(filterData!==false){
        setMinValue(0)
        setMaxValue(100)
      }
    },[cardNumber,filterData]);
    
  // const onMinValueChange = val => {
  //   console.log(val,maxValue,'valRaj1')
  //   setMinValue(val)
  //   setCompletionChange({ minValue: val, maxValue })
  // }
  // const onMaxValueChange = val => {
  //   console.log(minValue,val,'valRaj2')
  //   setMaxValue(val)
  //   setCompletionChange({ minValue: minValue, maxValue: val })
  // }
  return (
    <>
      <StyledHeading>Completion</StyledHeading>
      <StyledHeading color={COLORS.BLACK_WHITE_B_50}>
        {minValue}% - {maxValue}%
      </StyledHeading>

      <PercentageRangeSlider
        minValue={minValue}
        setMinValue={setMinValue}
        maxValue={maxValue}
        setMaxValue={setMaxValue}
        isStudent={true}
        setCompletionChange={setCompletionChange}
      />
    </>
  )
}

export default CompletionFilter
